import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AxiosApiClient from '../../components/utils/AxiosApiClient';
import AuthUtility from '../frontend/auth/AuthUtility';
import LoadingSpinner from '../frontend/LoadingSpinner';
import { getMimeType, explodeCategories, convertDateTimeToText, convertCentsToDollars } from '../utils/common';

import $ from 'jquery'; // Import jQuery
import swal from 'sweetalert';

import edit_icon from '../../assets/frontend/images/edit_icon.png';
import plus_icon_black from '../../assets/frontend/images/plus_icon_black.png';

const error_style = 'font-source-sans font-small font-weight-500 txt-000 bg-light-red p-5';

const per_page = 10;

function Plans() {

	const navHistory = useNavigate();

	console.log('Plans APP:', process.env.REACT_APP_NAME);

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	// using hooks
	const [isLoading, setIsLoading] = useState(false);
	const [isMounted, setIsMounted] = useState(false);
	const [plans, setPlans] = useState([
		//{ id: '', random_id: "", name: "", description: "", prrice_cents: "", ..... },
	]);
	const [plansMessage, setPlansMessage] = useState('Searrching For Plans');
	const [currentPage, setCurrentPage] = useState(1);
	const [lastPage, setLastPage] = useState(1);
	const [nextPage, setNextPage] = useState(null);
	const [prevPage, setPrevPage] = useState(null);
	const [viewMode, setViewMode] = useState('view_plans'); // 'view_plans' | 'save_plan'

	const initialPlanInput = {
		random_id: '',
		name: '',
		slug: '',
		description: '',
		price_cents: '',
		billing_interval: 'monthly', // monthly, yearly
		features: '',
		app: process.env.REACT_APP_NAME,
		status: '',
		stripe_price_id: '',
		errorList: [],
		errorStyle: [],
	};

	const [planInput, setPlanInput] = useState(initialPlanInput);

	const [newPlans, setNewPlans] = useState([
		//{ id: '', random_id: "", name: "", description: "", prrice_cents: "", ..... },
	]);
	const [editingPlan, setEditingPlan] = useState(null);

	// Initial call for user list items
	useEffect(() => {

		if (!AuthUtility.isLoggedIn()) {
			//user not authenticated on server so remove from local storage
			AuthUtility.clearAuthData()
			navHistory('/login');
		}

		if (isMounted) {
			console.log('[Account - useEffect] mounted');

			setViewMode('view_plans');

			var page = 1;
			readPlans(page);
		} else {
			setIsMounted(true);
		}

	}, [isMounted]);

	// READ PLANS
	function readPlans(page) {
		if (!AuthUtility.isLoggedIn()) {
			//user not authenticated on server so remove from local storage
			AuthUtility.clearAuthData();
			navHistory('/');
		}

		setIsLoading(true);

		const fetchApiDataReadPlans = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				
				/*
				const response = await makeRequestWithHeaders('get', '/api/read_plans/'+process.env.REACT_APP_NAME, null, {
					params: {
						per_page: per_page, // Set your preferred number of items per page
						page: page, // Specify the page number you want to fetch
					}
				});
				*/
				// Build URL with query parameters explicitly to ensure they are sent
				const url = `/api/read_plans/${process.env.REACT_APP_NAME}?per_page=${per_page}&page=${page}`;

				const response = await makeRequestWithHeaders('get', url);

				setApiDataReadPlans(response, "Plans.useEffect");
			} catch (error) {
				handleApiErrorReadPlans(error, "Plans.useEffect");
			}
		};
		fetchApiDataReadPlans();
	}

	function setApiDataReadPlans(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.message);

				//set data
				if (response.data.plans && response.data.plans.length > 0) {
					setPlans(response.data.plans);
					setCurrentPage(response.data.pagination_data.current_page);
					setLastPage(response.data.pagination_data.last_page);
					setNextPage(response.data.pagination_data.next_page);
					setPrevPage(response.data.pagination_data.prev_page);
					setPlansMessage('');
				} else {
					setPlans([]);
					setCurrentPage(null);
					setLastPage(null);
					setNextPage(null);
					setPrevPage(null);
					setPlansMessage('No Plans Exist');
				}

			} else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();
				navHistory('/login');
			} else if (response.data.status === 404) {//HTTP_NOT_FOUND
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//set data
				if (response.data.plans && response.data.plans.length > 0) {
					setPlans(response.data.plans);
					setCurrentPage(response.data.pagination_data.current_page);
					setLastPage(response.data.pagination_data.last_page);
					setNextPage(response.data.pagination_data.next_page);
					setPrevPage(response.data.pagination_data.prev_page);
					setPlansMessage('');
				} else {
					setPlans([]);
					setCurrentPage(null);
					setLastPage(null);
					setNextPage(null);
					setPrevPage(null);
					setPlansMessage('No Plans Exist');
				}
			} else if (response.data.status === 422) {//HTTP_UNPROCESSABLE_ENTITY
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//set data
				if (response.data.plans && response.data.plans.length > 0) {
					setPlans(response.data.plans);
					setCurrentPage(response.data.pagination_data.current_page);
					setLastPage(response.data.pagination_data.last_page);
					setNextPage(response.data.pagination_data.next_page);
					setPrevPage(response.data.pagination_data.prev_page);
					setPlansMessage('');
				} else {
					setPlans([]);
					setCurrentPage(null);
					setLastPage(null);
					setNextPage(null);
					setPrevPage(null);
					setPlansMessage('No Plans Exist');
				}
			} else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
				console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');
			} else {//more errors
			}
		}

		setIsLoading(false);
	}
	function handleApiErrorReadPlans(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		//user not authenticated on server so remove from local storage
		AuthUtility.clearAuthData();
		setIsLoading(false);
		swal("Error", error, "error");
	}

	const handleOpenPlanForm = (event, plan) => {
		event.preventDefault();

		setViewMode('save_plan');
	};
	function handleClosePlanForm(){
		setEditingPlan(null);        // set the plan being edited
		// Merge backend plan with defaults, so errorList & errorStyle exist
		setPlanInput({...initialPlanInput});
		setViewMode('view_plans');
	}

	const handleEditPlan = (plan) => {
    	//alert('Edit Plan: ' + plan.name + ' coming soon.');
		setEditingPlan(plan);        // set the plan being edited
		// Merge backend plan with defaults, so errorList & errorStyle exist
		setPlanInput({
			...initialPlanInput,  // ensures all keys are present
			...plan,              // overrides with actual plan values
		});
		setViewMode('save_plan');
	};

	// ADD PLAN
	const handlePlanInput = (event) => {
		event.persist();

		setPlanInput({ ...planInput, [event.target.name]: event.target.value });

		console.log('Plans: ',event.target.name, event.target.value);

		//remove the target error message no matter the new input, it will be validated on the server
		if (planInput.errorList.hasOwnProperty(event.target.name)) {
			delete planInput.errorList[event.target.name];
			delete planInput.errorStyle[event.target.name];
			$('#' + event.target.name + '_message').removeClass('hide') //clear any previous message
		}
	}

	const planSubmit = (event) => {
		event.preventDefault();

		setIsLoading(true);

		// Create FormData instance
		const formData = new FormData();
		formData.append('name', planInput.name);
		formData.append('slug', 'cr-test-slug');
		formData.append('description', planInput.description);
		formData.append('price_cents', planInput.price_cents);
		formData.append('billing_interval', planInput.billing_interval);
		formData.append('stripe_price_id', planInput.stripe_price_id);
		formData.append('app', planInput.app);

		if(editingPlan && editingPlan.random_id){
			formData.append('random_id', editingPlan.random_id);
			formData.append('mode', 'edit');
		}

		const fetchApiDataSavePlan = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				const response = await makeRequestWithHeaders('post', '/api/save_plan', formData, {
					params: {
						'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
					},
				});

				setApiDataSavePlan(response, "planSubmit");
			} catch (error) {
				handleApiErrorSavePlan(error, "planSubmit");
			}
		};

		fetchApiDataSavePlan();
	}

	function setApiDataSavePlan(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.message);

				setViewMode('view_plans');

				if(editingPlan && editingPlan.random_id){

					// add as a new plan to top of the list
					const updatedPlan = response.data.plan;
					setPlans((prevPlans) =>
					prevPlans.map((p) =>
						p.random_id === updatedPlan.random_id
						? { ...p, ...updatedPlan } // merge updated properties
						: p
					)
					);
					setEditingPlan(null);
					swal("Info", response.data.message + ": " +updatedPlan.name, "info");
				}else{

					// add as a new plan to top of the list
					const newPlan = response.data.plan;

					setNewPlans((prev) => [
						{
						...newPlan,
						price_cents: parseInt(newPlan.price_cents, 10), // normalize to integer
						},
						...prev, // prepend so newest is always on top
					]);
					swal("Info", response.data.message + ": " +newPlan.name, "info");
				}
				setPlanInput(initialPlanInput);

			} else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();
				navHistory('/login');
			} else if (response.data.status === 404) {//HTTP_NOT_FOUND
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				setIsLoading(false);
				swal("Warning", response.data.message, "warning");
			} else if (response.data.status === 422) {//HTTP_UNPROCESSABLE_ENTITY
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				setIsLoading(false);
				swal("Warning", response.data.message, "warning");
			} else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
				console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');

				var errorStyleTemp = JSON.parse(JSON.stringify(response.data.validation_errors));
				Object.keys(errorStyleTemp).map((key) => (
					errorStyleTemp[key] = error_style
				));
				Object.keys(errorStyleTemp).map((key) => (
					$('#' + key + '_message').addClass('hide') //clear any previous message
				));

				//validation errors mapped to input fields
				setPlanInput({ ...planInput, errorList: response.data.validation_errors, errorStyle: errorStyleTemp });
			} else {//more errors
			}
		}

		setIsLoading(false);
	}
	function handleApiErrorSavePlan(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		//user not authenticated on server so remove from local storage
		AuthUtility.clearAuthData();
		setIsLoading(false);
		swal("Error", error, "error");
	}

	// DELETE PLANS
	const handleConfirmToDeletePlan = (i) => {
		const list = [...plans];

		swal({
			title: 'Delete Plan',
			text: 'This will delete plan ' + list[i]['name'] + '.',
			icon: "warning",
			buttons: {
				cancel: true,
				confirm: {
					text: "Delete Plan",
					value: true,
				},
			},
			showCancelButton: true,
			confirmButtonText: "Yes, delete it!"
		}).then((result) => {
			if (result) {
				handleDeletePlan(i);
    			//alert('Plan Delete Coming Soon.');
			}
		});
	};

	// Delete row of id:i
	const handleDeletePlan = (i) => {
		const list = [...plans];

		// If the user confirms, proceed with the deletion
		if (list[i]['random_id'] && list[i]['random_id'] !== '') {
			deletePlan(list[i]['random_id']);//send a specific unique ID to delete
		}
	};

	function deletePlan(plan_random_id) {

		setIsLoading(true);

		const fetchApiDataDeletePlan = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				const response = await makeRequestWithHeaders('delete', '/api/delete_plan/' + process.env.REACT_APP_NAME + '/' + plan_random_id, null, {});

				setApiDataDeletePlan(response, "Plans.deletePlan", plan_random_id);
			} catch (error) {
				handleApiErrorDeletePlan(error, "Plans.deletePlan");
			}
		};

		fetchApiDataDeletePlan();
	}
	function setApiDataDeletePlan(response, theFunction, plan_random_id) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.message);

				//update state properties
				if (response.data.plans && response.data.plans.length > 0) {

					setPlans((prevPlans) =>
						prevPlans.filter((plan) => plan.random_id !== plan_random_id)
					);
				} else {
					setPlans([]);
				}

				swal("Deleted!", "Plan has been deleted.", "success");
			} else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();
				swal("Warning", response.data.message, "warning");
				navHistory('/login');
			} else if (response.data.status === 422) {//HTTP_UNPROCESSABLE_ENTITY
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				swal("Warning", response.data.message, "warning");
			} else {//more errors
			}
		}

		setIsLoading(false);
	}
	function handleApiErrorDeletePlan(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		//user not authenticated on server so remove from local storage
		AuthUtility.clearAuthData();
		setIsLoading(false);
		swal("Error", error, "error");
	}

	function PlanItem({ plan, index, onEdit, onDelete }) {
		var bg_class = '';
		if(index < 0){
			bg_class = (index % 2 === 0) ? 'bg-light-green' : 'bg-light-blue';
		}else{
			bg_class = (index % 2 === 0) ? 'bg-eee' : 'bg-fff';
		}
		return (
		<div className={"grid-x " + bg_class}>
			<div key={"no_edit_1_" + plan.id + plan.random_id} className="large-8 medium-8 small-12 cell p-10l-5s text-left">
				<div className="font-source-sans font-standard font-weight-500" valign="top">
				<div className="font-source-sans font-medium font-weight-800">{plan.name}</div>
				<div className="font-source-sans font-standard txt-555 pt-5">{plan.description}</div>
				<div className="font-source-sans font-standard font-weight-800 italic pt-5">
					<span className="font-weight-500">Stripe Price ID:</span> {plan.stripe_price_id}
				</div>
				</div>
			</div>

			<div key={"no_edit_2_" + plan.id + plan.random_id} className="large-2 medium-2 small-6 cell p-10l-5s text-left">
				<div className="font-source-sans font-standard font-weight-500" valign="top">
				<div className="font-standard txt-777 pt-5">${convertCentsToDollars(parseInt(plan.price_cents,10))}</div>
				<div className="font-standard txt-777 pt-5">{plan.billing_interval}</div>
				</div>
			</div>

			<div key={"no_edit_3_" + plan.id + plan.random_id} className="large-2 medium-2 small-6 cell p-10l-5s text-right">
				<div className="font-source-sans font-standard font-weight-500" valign="top">
				Created<div className="font-standard txt-777 ptb-5">{convertDateTimeToText(plan.created_at)}</div>
				Updated<div className="font-standard txt-777 pt-5">{convertDateTimeToText(plan.updated_at)}</div>
				</div>
			</div>

			<div key={"no_edit_4_" + plan.id + plan.random_id} className="large-12 medium-12 small-12 cell p-10">
				<span className="left">
				<Link onClick={() => onEdit(plan)}>Edit</Link>
				</span>
				<span className="float-right">
				<Link
					onClick={() => onDelete(index)}
					onTouchEnd={() => onDelete(index)}
				>
					Delete
				</Link>
				</span>
			</div>
		</div>
		);
	}

	return (
		<div className="body-content bg-fff pt-70l-110m-60s pb-90">

			{viewMode === 'view_plans' && (
			<>
			<div className="panel large pt-20l-10s">
				<div className="grid-x bb1-555 pb-5">
					<div className="large-10 medium-10 small-10 cell position-wrapper">
						<span className="font-source-sans font-size-24 font-weight-800 uppercase italic position-align-bottom">Plans</span>
					</div>
					<div className="large-2 medium-2 small-2 cell text-right">
						<Link  onClick={handleOpenPlanForm}  className="button icon tiny">
							<img src={plus_icon_black} alt="Add Plan" />
						</Link>
					</div>
				</div>
			</div>
			<div className="panel large mt-10">

				{plans.length > 0 ? (
					<div id="all_plans" className="b1-ccc">
						{newPlans.map((plan, i) => (
						<PlanItem
							key={plan.random_id}
							plan={plan}
							index={-1 - i} // -1, -2, -3...
							onEdit={handleEditPlan}
							onDelete={handleConfirmToDeletePlan}
						/>
						))}
						{plans.map((plan, i) => (
						<PlanItem
							key={plan.random_id}
							plan={plan}
							index={i}
							onEdit={handleEditPlan}
							onDelete={handleConfirmToDeletePlan}
						/>
						))}
					</div>
				) : (
					<div className="grid-x">
						<div className="large-12 medium-12 small-12 cell bg-fafafa b1-ccc p-20l-10s mt-5">
							<span className="font-source-sans font-size-18l-16m-14s font-weight-600 left">{plansMessage}</span>
						</div>
					</div>
				)}
				{plans.length > 0 && lastPage > 1 && (
					<div className="grid-x pt-10">
						<div id="plans_pagination" className="large-12 medium-12 small-12 cell pt-10">
							<ul className="pagination">
								{prevPage && (
									<li className="page-item">
										<Link className="page-link" onClick={() => readPlans(currentPage - 1)}>Previous</Link>
									</li>
								)}

								{[...Array(lastPage).keys()].map(page => (
									<li key={page + 1} className={`page-item ${page + 1 === currentPage ? 'active' : ''}`}>
										<Link className="page-link" onClick={() => readPlans(page + 1)}>{page + 1}</Link>
									</li>
								))}

								{nextPage && (
									<li className="page-item">
										<Link className="page-link" onClick={() => readPlans(currentPage + 1)}>Next</Link>
									</li>
								)}
							</ul>
						</div>
					</div>
				)}

				{isLoading &&
					<div className="grid-x">
						<div className="large-12 medium-12 small-12 cell text-center">
							<LoadingSpinner paddingclassName="p-20l-10s" />
						</div>
					</div>
				}

			</div>
			</>
			)}
			{viewMode === 'save_plan' && (
			<>
			<div className="panel large pt-20l-10s">
				<div className="grid-x bb1-555 pb-5">
					<div className="large-10 medium-10 small-10 cell position-wrapper">
						<span className="font-source-sans font-size-24 font-weight-800 uppercase italic position-align-bottom">New Plan</span>
					</div>
					<div className="large-2 medium-2 small-2 cell text-right">
						<Link  onClick={handleOpenPlanForm}  className="button icon tiny" disabled>
							<img src={plus_icon_black} alt="Add Plan" />
						</Link>
					</div>
				</div>
			</div>
			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell bg-fafafa b1-ccc p-10 ">
						<form onSubmit={planSubmit}>
							<div className="grid-x">
								<div className="large-6 medium-6 small-12 cell text-left pr-5l-0s">
									<div className={planInput.errorStyle.name}>{planInput.errorList.name}</div>
									<div className="p-5" id="name_message">&nbsp;</div>
									<input type="text" name="name" onChange={handlePlanInput} value={planInput.name} placeholder="Plan Name" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pl-5l-0s">
									<div className={planInput.errorStyle.description}>{planInput.errorList.description}</div>
									<div className="p-5" id="description_message">&nbsp;</div>
									<input type="text" name="description" onChange={handlePlanInput} value={planInput.description} placeholder="Plan Description" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pr-5l-0s">
									<div className={planInput.errorStyle.price_cents}>{planInput.errorList.price_cents}</div>
									<div className="p-5" id="price_cents_message">&nbsp;</div>
									<input type="text" name="price_cents" onChange={handlePlanInput} value={planInput.price_cents} placeholder="Price Cents" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pl-5l-0s">
									<div className={planInput.errorStyle.billing_interval}>{planInput.errorList.billing_interval}</div>
									<div className="p-5" id="billing_interval_message">&nbsp;</div>
									<select name="billing_interval" onChange={handlePlanInput} value={planInput.billing_interval}>
										<option disabled>Billing Interval</option>
										<option value="monthly">Monthly</option>
										<option value="yearly">Yearly</option>
									</select>
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pr-5l-0s">
									<div className={planInput.errorStyle.stripe_price_id}>{planInput.errorList.stripe_price_id}</div>
									<div className="p-5" id="stripe_price_id_message">&nbsp;</div>
									<input type="text" name="stripe_price_id" onChange={handlePlanInput} value={planInput.stripe_price_id} placeholder="Stripe Price ID" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pl-5l-0s"></div>
								<div className="large-6 medium-6 small-6 cell text-left pt-20">
									<button onClick={handleClosePlanForm} className="button width-125px-100px">Cancel</button>
								</div>
								<div className="large-6 medium-6 small-6 cell text-right pt-20">
									<div className="horizontal-container float-right">
										{isLoading &&
											<span className="element pr-10">
												<LoadingSpinner paddingclassName="none" sizeclassName="none" />
											</span>
										}
										<span className="element">
											<button type="submit" className="button width-125px-100px">Submit</button>
										</span>
									</div>
								</div>
							</div>
						</form>
					</div>

				</div>
			</div>
			</>
			)}

		</div>
	);
}

export default Plans;